export const cooperativeEn = {
  cooperative: {
    // Member Management
    searchMembers: "Search Members",
    searchPlaceholder: "Search by name, email, or member code...",
    filters: "Filters",
    memberSince: "Member since",
    parcels: "parcels",
    ndviAverage: "NDVI Average",
    performanceScore: "Performance Score",
    activeAlerts: "Active Alerts",
    viewDetails: "View Details",
    contact: "Contact",
    noMembersFound: "No members found matching your search.",
    unknownMember: "Unknown Member",
    active: "Active",

    // Communication Hub
    emailSent: "Email Sent",
    smsSent: "SMS Sent",
    openRate: "Open Rate",
    emailEngagement: "Email engagement",
    responseRate: "Response Rate",
    memberResponses: "Member responses",
    thisMonth: "This month",
    composeMessage: "Compose Message",
    messageHistory: "Message History",
    templates: "Templates",
    sendMassCommunication: "Send Mass Communication",
    selectRecipients: "Select Recipients",
    allMembers: "All Members",
    withActiveAlerts: "With Active Alerts",
    lowPerformance: "Low Performance",
    communicationChannels: "Communication Channels",
    subject: "Subject",
    enterSubject: "Enter message subject...",
    message: "Message",
    writeMessage: "Write your message here...",
    characters: "characters",
    smsSegments: "SMS segments",
    sendMessage: "Send Message",
    saveAsDraft: "Save as Draft",
    messageSent: "Message Sent",
    messageSentDesc: "Message sent to selected members successfully",
    communicationHistory: "Communication History",
    recipients: "recipients",
    delivered: "delivered",
    messageTemplates: "Message Templates",
    useTemplate: "Use Template",
    communicationAnalytics: "Communication Analytics",
    totalSent: "Total Sent",
    opened: "Opened",
    replied: "Replied",

    // Financial Dashboard
    revenueProjection: "Revenue Projection",
    estimatedAnnualRevenue: "Estimated annual revenue",
    vsLastYear: "vs last year",
    revenuePerMember: "Revenue per Member",
    averagePerMember: "Average per member",
    members: "members",
    revenuePerHectare: "Revenue per Hectare",
    perHectareManaged: "Per hectare managed",
    haTotal: "ha total",
    serviceRevenue: "Service Revenue",
    fromSharedServices: "From shared services",
    margin: "margin",
    revenueStreams: "Revenue Streams",
    agriculturalProduction: "Agricultural Production",
    ofTotalRevenue: "of total revenue",
    sharedEquipmentServices: "Shared Equipment Services",
    bulkPurchasingMargin: "Bulk Purchasing Margin",
    technicalAdvisory: "Technical Advisory",
    operatingCosts: "Operating Costs",
    equipmentMaintenance: "Equipment Maintenance",
    staffSalaries: "Staff Salaries",
    administrative: "Administrative",
    marketing: "Marketing",
    totalOperatingCosts: "Total Operating Costs",
    financialHealth: "Financial Health",
    grossRevenue: "Gross Revenue",
    netProfit: "Net Profit",
    profitMargin: "Profit Margin",

    // Group Insurance
    activePolicies: "Active Policies",
    groupInsurancePolicies: "Group insurance policies",
    totalCoverage: "Total Coverage",
    insuredAmount: "Insured amount",
    insuredMembers: "Insured Members",
    coveredFarmers: "Covered farmers",
    lossRatio: "Loss Ratio",
    claimsVsPremiums: "Claims vs premiums",
    riskPortfolio: "Risk Portfolio Diversification",
    droughtCoverage: "Drought Coverage",
    excessRain: "Excess Rain",
    frostProtection: "Frost Protection",
    multiPeril: "Multi-Peril",
    groupInsurancePoliciesTitle: "Group Insurance Policies",
    newPolicy: "New Policy",
    loadingPolicies: "Loading policies...",
    noPoliciesFound: "No group insurance policies found.",
    createFirstPolicy: "Create First Policy",
    coverage: "Coverage",
    premium: "Premium",
    period: "Period",
    recentClaimsActivity: "Recent Claims Activity",
    pendingClaims: "Pending Claims",
    approvedThisMonth: "Approved (This Month)",
    totalPayoutThisMonth: "Total Payout (This Month)",
    avgProcessingTime: "Avg Processing Time",
    premiumCollection: "Premium Collection",
    totalPremiumPool: "Total Premium Pool",
    collected: "Collected",
    pending: "Pending",
    collectionRate: "Collection Rate",

    // Market Intelligence
    trackedCommodities: "Tracked Commodities",
    activePriceFeeds: "Active price feeds",
    bullishForecasts: "Bullish Forecasts",
    expectedPriceIncreases: "Expected price increases",
    marketSources: "Market Sources",
    dataProviders: "Data providers",
    currentPrices: "Current Prices",
    priceForecasts: "Price Forecasts",
    exportOpportunities: "Export Opportunities",
    realTimePrices: "Real-Time Commodity Prices",
    loadingPrices: "Loading prices...",
    noPriceData: "No price data available. Connect to commodity price feeds.",
    lastUpdated: "Last updated",
    marketForecasts: "Market Forecasts & Trends",
    loadingForecasts: "Loading forecasts...",
    noForecastData: "No forecast data available.",
    confidence: "confidence",
    forecast: "forecast",
    currentPrice: "Current Price",
    forecastMin: "Forecast Min",
    forecastMax: "Forecast Max",
    priceAlerts: "Price Alerts & Notifications",

    // Regional Benchmark
    regionalComparison: "Regional Comparison",
    cooperativesInRegion: "cooperatives in the region",
    averageNdvi: "Average NDVI",
    regionalAvg: "Regional avg",
    areaPerMember: "Area per Member",
    regionalRanking: "Regional Ranking",
    overallRanking: "Overall Ranking",
    basedOnMetrics: "Based on multiple performance metrics",
    outOf: "out of",
    ndviRanking: "NDVI Ranking",
    efficiencyRanking: "Efficiency Ranking",
    growthRanking: "Growth Ranking",
    sustainabilityRanking: "Sustainability Ranking",
    keyInsights: "Key Insights",

    // Reports Generator
    reportTemplates: "Report Templates",
    generate: "Generate",
    schedule: "Schedule",
    recentReports: "Recent Reports",
    scheduledReports: "Scheduled Reports",
    nextRun: "Next run",
    edit: "Edit",
    dataExport: "Data Export",
    exportMemberData: "Export Member Data",
    exportParcelAnalytics: "Export Parcel Analytics",
    exportFinancialData: "Export Financial Data",
    generatingReport: "Generating Report",
    reportBeingGenerated: "Your report is being generated...",
    reportGenerated: "Report Generated",
    reportGeneratedDesc: "Your report has been generated successfully",
    reportScheduled: "Report Scheduled",
    reportScheduledDesc: "Report will be automatically generated and sent on the scheduled date",

    // Role Management
    roleManagement: "Role Management",
    managers: "Managers",
    financial: "Financial",
    technical: "Technical",
    loadingRoles: "Loading roles...",
    noUsersFound: "No users found",
    cancel: "Cancel",
    roleUpdated: "Role Updated",
    roleUpdatedDesc: "User role has been updated successfully",
    permissionsMatrix: "Permissions Matrix",
    permission: "Permission",
    manager: "Manager",
    viewAllData: "View All Data",
    manageMembers: "Manage Members",
    manageFinancial: "Manage Financial",
    manageTechnical: "Manage Technical",
    sendCommunications: "Send Communications",
    manageInsurance: "Manage Insurance",
    viewFinancial: "View Financial",
    fullAccess: "Full access to all cooperative functions",
    manageFinancialDesc: "Manage financial data and insurance",
    manageTechnicalDesc: "Manage technical aspects and communications",
    viewOnly: "View cooperative information only"
  }
};